import React, { useState } from 'react';
import { WisdomScrollIcon, AlchemyGoldIcon } from './CustomIcons';

/**
 * Lore Drop Animation + Button
 * Spirals all accumulated lore into the chat
 * Fun visual effect + starts discussion from lore
 */
const LoreDropper = ({ onDropLore, loreSummary, variant = 'terminal' }) => {
  const [isDropping, setIsDropping] = useState(false);

  const handleDrop = async () => {
    setIsDropping(true);
    
    // Trigger the drop after animation starts
    setTimeout(() => {
      if (onDropLore) {
        onDropLore(loreSummary);
      }
      setIsDropping(false);
    }, 2000); // 2 second spiral animation
  };

  const colors = variant === 'terminal'
    ? { primary: '#a855f7', glow: 'rgba(168, 85, 247, 0.5)' }
    : { primary: '#a855f7', glow: 'rgba(168, 85, 247, 0.4)' };

  return (
    <>
      <button
        onClick={handleDrop}
        disabled={isDropping}
        className={`px-4 py-2 rounded-lg border transition-all flex items-center gap-2 ${
          variant === 'terminal' 
            ? 'bg-purple-600/20 hover:bg-purple-600/40 border-purple-500/50 text-purple-300'
            : 'bg-purple-100/10 hover:bg-purple-100/20 border-purple-400/30 text-purple-300'
        }`}
        style={{
          fontFamily: variant === 'terminal' ? 'monospace' : '"Crimson Text", serif',
          boxShadow: isDropping ? `0 0 30px ${colors.glow}` : 'none'
        }}
        title="Drop accumulated lore into chat"
      >
        <AlchemyGoldIcon size={16} color={colors.primary} className={isDropping ? 'animate-spin' : ''} />
        <span>Drop Lore</span>
      </button>

      {/* Spiral Animation Overlay */}
      {isDropping && (
        <div className="fixed inset-0 z-[150] pointer-events-none">
          <div 
            className="absolute inset-0 flex items-center justify-center"
            style={{
              background: 'radial-gradient(circle, rgba(168, 85, 247, 0.2) 0%, transparent 70%)',
              animation: 'spiralDrop 2s ease-out'
            }}
          >
            <WisdomScrollIcon 
              size={120} 
              color={colors.primary}
              style={{
                animation: 'spiralSpin 2s ease-out',
                filter: `drop-shadow(0 0 40px ${colors.glow})`
              }}
            />
          </div>
        </div>
      )}
      
      <style>{`
        @keyframes spiralDrop {
          0% {
            transform: scale(3) rotate(0deg);
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            transform: scale(0.5) rotate(720deg);
            opacity: 0;
          }
        }
        
        @keyframes spiralSpin {
          0% {
            transform: scale(3) rotate(0deg);
          }
          100% {
            transform: scale(0.3) rotate(1080deg);
          }
        }
      `}</style>
    </>
  );
};

export default LoreDropper;
